import mwcMarketsCore from 'mwc-markets-core';
import News from './src/news.vue';

const { createCustomElement } = mwcMarketsCore;
createCustomElement(News);

export default News;
